<div class="p-fluid">
  <crm-checklist-period-form
    appendTo="body"
    [(startAt)]="dealEvent.startAt"
    [(endAt)]="dealEvent.endAt"
    [errors]="errors"
    [canDelete]="canDelete"></crm-checklist-period-form>

  <div class="field">
    <label class="font-medium required-field">Комментарий</label>
    <crm-editor
      [(value)]="dealEvent.reason"
      height="110px"></crm-editor>
    <small
      *ngIf="errors?.reason"
      class="p-error">
      {{ errors.reason | join }}
    </small>
  </div>
</div>

<div class="mt-3">
  <button
    pButton
    [label]="saveButtonLabel"
    class="p-button-success"
    (click)="onSave(dealEvent)"></button>
</div>
